export class ShowPageState {

    constructor() {
        this._versionApplied = window.ShowPageState?._versionApplied || null;
    }

    /**
     * The classic Singleton access method
     */
    static getInstance() {
        if (!window.ShowPageState) {
            window.ShowPageState = new ShowPageState();
        }
        return window.ShowPageState;
    }

    setVersionApplied(v) {
        this._versionApplied = v;
    }

    getVersionApplied() {
        return this._versionApplied;
    }
}
